import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';
import CommentsList from './components/commentsList';
import AddComment from './components/addComment';

const OrderComments = ({ orderData, userRights }) => {
  const {
    ORDERS: { ORDER_COMMENTS }
  } = useLocalizedStringsContext();

  const { canAddComments } = userRights;

  const [newCommentAdded, setNewCommentAdded] = useState(false);
  return (
    <StackView space={2}>
      <Typography heading="h3" variant={{ size: 'h3' }} block>{ORDER_COMMENTS}</Typography>
      <CommentsList orderData={orderData} newCommentAdded={newCommentAdded} />
      {canAddComments && (
        <AddComment
          setNewCommentAdded={setNewCommentAdded}
          orderData={orderData}
        />
      )}
    </StackView>
  );
};

OrderComments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default OrderComments;
